<template>
  <ul class="footer-links">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  name: 'FooterLinksList'
}
</script>

<style scoped>
.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 0.75rem;
}
</style>

